// The window.UPDATE_SIGNAL is comes from the 'ssr' mixin

export default {
  data() {
    return {
      isMounted: false
    };
  },

  mounted() {
    this.isMounted = true;
    window.UPDATE_SIGNAL?.notify();
  },

  beforeDestroy() {
    this.isMounted = false;
    window.UPDATE_SIGNAL?.notify();
  }
};
